import { Modal, Tabs, TabsProps } from 'antd';
import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import StockImagesTab from './tabs/StockImagesTab';
import YourWebsiteImagesTab from './tabs/YourWebsiteImagesTab';
import UploadImageTab from './tabs/UploadImageTab';
import PictureModel from '../../../../model/picture/PictureModel';
import IframeServiceInjector from '../../../../services/injectors/IframeServiceInjector';
import FrameEventMessanger from '../../../../services/frames/FrameEventMessanger';
import { PICTURE_CHANGE } from '../../../../consts/events';

interface FCProps {}

const PictureEditModal: React.FC<FCProps> = observer(({}) => {
  const { t } = useTranslation();
  const tabRef = React.useRef(null);
  const [loadingImageForPreview, setLoadingImageForPreview] =
    React.useState(false);

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: t('Stock images'),
      children: (
        <div ref={tabRef} className="max-h-[500px] overflow-auto">
          <StockImagesTab
            scrollTab={() => {
              if (tabRef.current) {
                tabRef.current.scrollTop = tabRef.current.scrollHeight;
              }
            }}
          />
        </div>
      )
    },
    {
      key: '2',
      label: t('Your website images'),
      children: (
        <div className="max-h-[500px] overflow-auto">
          <YourWebsiteImagesTab />
        </div>
      )
    },
    {
      key: '3',
      label: t('Upload image'),
      children: (
        <div className="max-h-[500px] overflow-auto">
          <UploadImageTab />
        </div>
      )
    }
  ];

  if (PictureModel.pictureEditModalOpened !== null) {
    return (
      <Modal
        title={t('Edit image')}
        open={true}
        onOk={async () => {
          setLoadingImageForPreview(true);

          const imageForPreviw =
            await PictureModel.selectedPicture.getImageForPreview();

          IframeServiceInjector.getService<FrameEventMessanger>(
            'FrameEventMessanger'
          ).sendMessage(PICTURE_CHANGE, {
            elementId: PictureModel.pictureEditModalOpened,
            imgUrl: imageForPreviw
          });

          PictureModel.reset();
          PictureModel.closePictureEditModal();

          setLoadingImageForPreview(false);
        }}
        okText={t('save_modal')}
        cancelText={t('Cancel')}
        onCancel={() => {
          PictureModel.reset();
          PictureModel.closePictureEditModal();
        }}
        okButtonProps={{
          children: t('Save'),
          disabled: PictureModel.selectedPicture === null,
          loading: loadingImageForPreview
        }}
        cancelButtonProps={{
          children: t('Cancel')
        }}>
        <Tabs defaultActiveKey="1" items={items} />
      </Modal>
    );
  }

  return null;
});

export default PictureEditModal;
